<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon lock-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g id="lock">
      <g id="Group">
        <path
          id="Vector"
          d="M6.78735 8.96818V5.48409C6.78735 4.56005 7.15443 3.67386 7.80782 3.02047C8.46121 2.36707 9.34741 2 10.2714 2V2C10.729 2 11.182 2.09012 11.6047 2.26521C12.0275 2.4403 12.4115 2.69694 12.7351 3.02047C13.0586 3.34399 13.3152 3.72808 13.4903 4.15079C13.6654 4.5735 13.7555 5.02655 13.7555 5.48409V8.96818"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          id="Vector_2"
          d="M16.5427 8.96819H4V17.33H16.5427V8.96819Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </g>
  </BaseSvg>
</template>
